export default __webpack_public_path__ + "static/media/risk-result-6.7efb8199.svg";